import React from "react";
import { Button } from "@mui/material";

const PaginationControls = ({ hasMore, onNextPage, onPrevPage, offset }) => {
  return (
    <div style={{ marginTop: "20px", textAlign: "center" }}>
      <Button
        variant="contained"
        onClick={onPrevPage}
        disabled={offset === 0}
        style={{
          fontFamily: "Poppins, sans-serif",
          backgroundColor: offset === 0 ? "#5c677d" : "#00171f",
          color: "#fff",
        }}
      >
        Previous Page
      </Button>
      <Button
        variant="contained"
        onClick={onNextPage}
        disabled={!hasMore}
        style={{
          marginLeft: "10px",
          fontFamily: "Poppins, sans-serif",
          backgroundColor: !hasMore ? "#5c677d" : "#00171f",
          color: "#fff",
        }}
      >
        Next Page
      </Button>
    </div>
  );
};

export default PaginationControls;
